import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Output() onUploadClick = new EventEmitter();
  @Input() title: string;
  @Input() secClass: string;
  constructor() {}

  clickButton() {
    this.onUploadClick.emit();
  }
}